module.exports = __webpack_public_path__ + "img/锦江宾馆详情.8581ebfc.jpg";